import React, { FC, useState, useEffect } from "react";
import { service } from "../../../services/AxiosServices";
import { useNavigate, useParams } from "react-router-dom";
import "../../static/css/Sidebar.css";
import Backicon from "../../static/svg/Backicon";
import Pluseicon_sidebar from "../../static/svg/Pluseicon_sidebar";
import AI_spaceicon from "../../static/svg/AI_spaceicon";
import HistorySidebarItem from "../molecules/HistorySidebarItem";
import { useChatContext } from "../../../context/ChatContext";
import Button from "../atoms/Button";
import Spinner from "../atoms/Spinner";
import { useTheme } from "../../../context/ThemeContext"

interface Props {
  Id?: string;
  spaceChat: boolean;
  toggle: boolean;
  setToggle: React.Dispatch<React.SetStateAction<boolean>>;
}

const HistorySidebar: FC<Props> = ({ Id, spaceChat, toggle, setToggle }) => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const { 
    chatHistory, 
    setChats, 
    setChatHistory, 
    fetchChatHistory, 
    loading, 
    currentSectionId,
    setCurrentSectionId,
    saveCurrentState,
    setIsProcessingRequest
  } = useChatContext();
  
  const { id } = useParams();
  const { isDarkMode, toggleTheme } = useTheme();
  const [fetchingSection, setFetchingSection] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (id) fetchChatHistory(id, spaceChat);
  }, [id, fetchChatHistory]);

  const fetchChatSection = async (sectionId: number) => {
    if (fetchingSection) return;
    if (currentSectionId === sectionId.toString()) return; // Don't refetch if already on this section
    
    try {
      // Save current state before switching
      if (currentSectionId) {
        saveCurrentState();
      }
      
      setFetchingSection(true);
      setCurrentSectionId(sectionId.toString());
      
      const endPoint = spaceChat
        ? "api/get-ai-sapce-chat-section"
        : "/api/getchatsection";
      const requestBody: Record<string, any> = {
        ...(spaceChat ? { space_id: Id } : { crew: Id }),
        ...(spaceChat ? {} : { project_id: localStorage.getItem("project_id") }),
        section_id: sectionId,
      };

  

      const response = await service<any>(endPoint, "post", requestBody);

      // Transform the tasks data
      const formattedChats = response.data.tasks.map((task: any) => ({
        id: task.id,
        task_description: task.task_description,
        response: task.response,
        section_id: sectionId.toString(),
      }));

      // Update the chats with the new data
      setChats(formattedChats);
    } catch (err) {
      console.error("Error fetching chat section:", err);
    } finally {
      setFetchingSection(false);
    }
  };

  const handleNewChat = () => {
    // Save current state
    if (currentSectionId) {
      saveCurrentState();
    }
    
    // Reset for new chat
    setChats([]);
    setCurrentSectionId(null);
    setIsProcessingRequest(false);
  };

  return (
    <>
      {isSidebarVisible && (
        <div className={`sidebar-space ${isDarkMode ? 'dark-textarea' : 'bg-light-mode-sidebar '}`}>
          <div className="mt-5 px-4 pt-3">
            <span className=""
              role="button"
              style={{ cursor: "pointer" }}
              onClick={() => setToggle(!toggle)}
            >
              <AI_spaceicon />
            </span>
          </div>
          <div className="history-list ps-4">
            <div className={`History-title my-3 ${isDarkMode ? "History-title-dark":""}`}>History</div>
            <div className="">
              {loading ? (
                <Spinner />
              ) : chatHistory.length === 0 ||
                (chatHistory.length === 1 &&
                  chatHistory[0].desc === "No history") ? (
                <div className={`${isDarkMode ? "dark-textarea": "bg-light-mode-sidebar"}`}>No history available</div>
              ) : (
                chatHistory.map((history, index) => (
                  <HistorySidebarItem
                    key={index}
                    text={`${history.desc || `history ${history.id}`}`}
                    onClick={() => {
                      fetchChatSection(Number(history.id));
                    }}
                    isActive={currentSectionId === history.id}
                    isDarkMode={isDarkMode}
                  />
                ))
              )}
            </div>
          </div>
          <div className="New-chart-btn mx-4 my-2">
            <Button
              onClick={handleNewChat}
              className="text-white"
            >
              + New chat
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default HistorySidebar;